import { Box, Radio, RadioGroup, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const RadioGroupWrapper = styled(Box)(({ theme }) => {
  return {
    marginBottom: '20px',
  };
}) as typeof Box;

export const RadioGroupLabel = styled(Typography)(({ theme }) => {
  return {
    color: palette.text.header,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '128%',
    margin: '0 0 13px 0',
  };
}) as typeof Typography;

export const CustomRadioGroup = styled(RadioGroup)({
  display: 'flex',

  '.MuiFormControlLabel-root': {
    marginLeft: '0',
    marginRight: '0',

    '& .MuiTypography-root': {
      color: palette.text.header,
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '136%',
    },
  },
}) as typeof RadioGroup;

export const CustomRadio = styled(Radio)({
  width: '18px',
  height: '40px',
  padding: '0',
  marginRight: '8px',

  '&.Mui-checked': {
    '&.Mui-disabled': {
      '.MuiSvgIcon-root': {
        fill: palette.unknown.checkbox_disabled_grey,
      },
    },
    '.MuiSvgIcon-root': {
      fill: palette.alerts.success,
    },
  },

  '&.Mui-disabled': {
    '.MuiSvgIcon-root': {
      fill: palette.unknown.checkbox_disabled_grey,
    },
  },

  '.MuiSvgIcon-root': {
    fill: palette.black,

    '&:disabled': {
      fill: palette.unknown.checkbox_disabled_grey,
    },
  },
}) as typeof Radio;
